import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ManutencaoService {
  private data = null;
  private url = environment.serviceApi;
  
  constructor(public http: Http) { }

  	getManutencoes() {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/manutencao/')
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

  	getManutencao(manutencao) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/manutencao/' + manutencao)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

  	getManutencoesByStatus(status) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/manutencao/status/' + status)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
	
  	getManutencaoByVeiculoAndDespesa(veiculo, despesa) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/manutencao/' + veiculo + '/' + despesa)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
  	getManutencaoByVeiculo(veiculo) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/manutencao/veiculo/' + veiculo)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaManutencao(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/manutencao', {
				usuario_id: data.usuario_id,
				tipo_manutencao_id: data.tipo_manutencao_id,
				veiculo_id: data.veiculo_id,
				oficina_id: data.oficina_id,
				manutencao_data_abertura: data.manutencao_data_abertura,
				manutencao_hora_abertura: data.manutencao_hora_abertura,
				manutencao_data_conclusao: data.manutencao_data_conclusao,
				manutencao_hora_conclusao: data.manutencao_hora_conclusao,
				manutencao_solicitante: data.manutencao_solicitante,
				manutencao_aprovador: data.manutencao_aprovador,
				manutencao_descricao: data.manutencao_descricao,
				manutencao_valor: data.manutencao_valor,
				pecas: data.pecas,
				servicos: data.servicos
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaManutencao(data) {
		console.log("[editaManutencao]", data);
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/manutencao/' + data.manutencao_id, {
				usuario_id: data.usuario_id,
				tipo_manutencao_id: data.tipo_manutencao_id,
				veiculo_id: data.veiculo_id,
				oficina_id: data.oficina_id,
				manutencao_data_abertura: data.manutencao_data_abertura,
				manutencao_hora_abertura: data.manutencao_hora_abertura,
				manutencao_data_conclusao: data.manutencao_data_conclusao,
				manutencao_hora_conclusao: data.manutencao_hora_conclusao,
				manutencao_solicitante: data.manutencao_solicitante,
				manutencao_aprovador: data.manutencao_aprovador,
				manutencao_descricao: data.manutencao_descricao,
				manutencao_valor: data.manutencao_valor,
				pecas: data.pecas,
				servicos: data.servicos,
				manutencao_peca_visualizado: ''
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaManutencaoIntervencoes(data) {
		console.log("[editaManutencao]", data);
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/manutencao/' + data.manutencao_id, 
			{
				manutencao_peca_visualizado: data.manutencao_peca_visualizado
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	atualizaManutencoes(){
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/manutencao/atualizaManutencao')
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getManutencoesByUsuario(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/manutencao/usuario/' + usuario_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaManutencao(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/manutencao/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}


}
